import { render, staticRenderFns } from "./NegocioOrcamentosDivisao.vue?vue&type=template&id=37572515&"
import script from "./NegocioOrcamentosDivisao.vue?vue&type=script&lang=js&"
export * from "./NegocioOrcamentosDivisao.vue?vue&type=script&lang=js&"
import style0 from "./NegocioOrcamentosDivisao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports